<template>
  <div>
    <el-descriptions :column="1" border>
      <el-descriptions-item label="TikHub 状态">{{ configured ? '已连接' : '未连接' }}</el-descriptions-item>
      <el-descriptions-item label="当前凭证">{{ value.masked_key || '-' }}</el-descriptions-item>
    </el-descriptions>

    <div v-if="!configured || editing" class="credential-form">
      <el-input
        v-model.trim="key"
        type="password"
        show-password
        :disabled="saving||deleting"
        :placeholder="configured ? '输入新的 TikHub API Key' : '粘贴 TikHub API Key'"
      />
      <el-button type="primary" class="mt" :loading="saving" :disabled="deleting" @click="save">{{ saving ? '保存中' : configured ? '保存修改' : '保存并连接' }}</el-button>
      <el-button v-if="configured" class="mt" :disabled="saving||deleting" @click="cancelEdit">取消</el-button>
    </div>

    <div v-else class="actions">
      <el-button type="primary" plain :disabled="deleting" @click="editing = true">修改凭证</el-button>
      <el-button type="danger" plain :loading="deleting" @click="removeKey">{{deleting?'删除中':'删除凭证'}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'saving', 'deleting'],
  data () {
    return {
      key: '',
      editing: false
    }
  },
  computed: {
    configured () {
      return Boolean(this.value && this.value.configured)
    }
  },
  watch: {
    value: {
      deep: true,
      handler () {
        this.key = ''
        this.editing = false
      }
    }
  },
  methods: {
    save () {
      if (this.saving || this.deleting) return
      if (!this.key) return this.$message.warning('请输入 TikHub API Key')
      this.$emit('save-key', this.key)
    },
    cancelEdit () {
      this.key = ''
      this.editing = false
    },
    removeKey () {
      if (this.saving || this.deleting) return
      this.$confirm('删除后将无法继续调用 TikHub，重新配置后才能恢复。确定删除当前凭证吗？', '删除 TikHub 凭证', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('delete-key')
      }).catch(() => undefined)
    }
  }
}
</script>

<style scoped>
.credential-form,
.actions {
  margin-top: 16px;
}
.mt {
  margin-top: 16px;
}
</style>
